import {noop} from '@github-ui/noop'
import type {UseMutationResult} from '@tanstack/react-query'
import {useCallback} from 'react'

type MutateAsyncCallback<TData, TVariables, TError, TContext> = (
  ...args: Parameters<UseMutationResult<TData, TError, TVariables, TContext>['mutateAsync']>
) => Promise<TData | void>

export function useWrapMutationMutateAsync<TData, TError, TVariables, TContext>(
  mutation: UseMutationResult<TData, TError, TVariables, TContext>,
) {
  const mutateAsync = useCallback<MutateAsyncCallback<TData, TVariables, TError, TContext>>(
    (...args) => {
      return mutation.mutateAsync(...args).catch(noop)
    },
    [mutation],
  )

  return {mutation, mutateAsync}
}
